import { Flex } from "antd";
import styled from "styled-components";

export const ContactsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: -120px;
  z-index: 2;
  width: 350px;
  flex-shrink: 0;
  text-transform: none;

  @media (max-width: 768px) {
    margin-top: 0;
    width: 100%;
  }
`

export const ContactItem = styled(Flex)`
  align-items: center;
  max-width: 320px;
  font-size: 1.4em;
  font-weight: 500;

  & > svg, & > .anticon {
    width: 1em;
    height: 1em;
    margin-right: 8px;
  }
`
